const links = document.querySelectorAll('.flexible a');
const protocol = /^https?:\/\/([^\/]*)\//;
const mailto = /mailto:([^\/]*)/;
for (let link of links){
        let href = link.href;
        let httpsMatches = href.match(protocol);
        let mailtoMatches = href.match(mailto);

        if(httpsMatches !== null){
                if (httpsMatches[1] && httpsMatches[1] !== window.location.host) {
                    link.setAttribute("target","_blank");
                }
        }
        else if(mailtoMatches !== null){
                link.setAttribute("target","_blank");
        }
}

